import React, { useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import VideoPlayer, { ReviewStaric } from "../../components/SatCourse/VideoPlayer";

export interface VideoPlayerScreenProps {}

const VideoPlayerScreen: React.FC<VideoPlayerScreenProps> = (props) => {
  const navigate = useNavigate();
  const useLocations = useLocation();

  const id = useLocations.state?.id || "";
  const chaperTitle = useLocations.state?.title || "";
  const topicTitle = useLocations.state?.topicTitle || "";
  const description = useLocations.state?.description || "";
  const videoUrl = useLocations.state?.videoUrl || "";
  const pdfUrl = useLocations.state?.pdfUrl || "";

  const [isLoading] = useState<boolean>(false);
  const [isError] = useState<string>("");
  const [video] = useState<string>("");
  const [innerWidth, setInnerWidth] = useState<number>(window.innerWidth);
  const [checkClampLines, setCheckClampLines] = useState<boolean>(true);
  const videoRef = useRef<any>(null);
  const [playedPercentage, setPlayedPercentage] = useState<number>(0);
  const [timer, setTimer] = useState<number>(0);
  const [isEqual, setIsEqual] = useState<boolean>(false);
  const [, setNoOfStarics] = useState<number>(0);
  const [checkVideoPause, setCheckVideoPause] = useState<boolean>(true);
  
  const [reviewStaric, setReviewStaric] = useState<ReviewStaric[]>([
    { id: 1, isFilled: false },
    { id: 2, isFilled: false },
    { id: 3, isFilled: false },
    { id: 4, isFilled: false },
    { id: 5, isFilled: false },
  ]);

  useEffect(() => {
    if (checkVideoPause === true) {
      if (timer <= playedPercentage) {
        const interval = setInterval(() => {
          setTimer((prevTimer) => prevTimer + 1);
        }, 1000);
        
        if (timer === playedPercentage && timer > 0) {
          setIsEqual(true);
          console.log("80%  completed");
        }

        return () => clearInterval(interval);
      }
    }
  }, [timer, playedPercentage, checkVideoPause]);

  const handleResize = useCallback(() => {
    setInnerWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  const CalculatePercentage = useCallback(() => {
    if (videoRef.current) {
      const videoDuration = videoRef.current.duration;
      const calculatedPercentage = parseInt(videoDuration) * 0.75;
      setPlayedPercentage(parseInt(calculatedPercentage.toString()));
    }
  }, []);

  const handlePlay = useCallback(() => {
    setCheckVideoPause(true);
    CalculatePercentage();
  }, [CalculatePercentage]);

  const HandleNextVideo = useCallback(() => {
    console.log("I am gere br");
  }, []);

  const HandleArrow = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const HandleSubmit = useCallback(() => {}, []);

  const HandleStaric = useCallback((index: number) => {
    const temp = [...reviewStaric];
    for (let i = 0; i <= index; i++) {
      temp[i].isFilled = true;
    }
    for (let i = index + 1; i < temp.length; i++) {
      temp[i].isFilled = false;
    }

    setReviewStaric(temp);
    setNoOfStarics(index + 1);
  }, [reviewStaric]);

  const HandlePauseVideo = useCallback(() => {
    setCheckVideoPause(false);
  }, []);

  return (
    <>
      <VideoPlayer
        id={id}
        chapterTitle={chaperTitle}
        topicTitle={topicTitle}
        description={description}
        video={video}
        isLoading={isLoading}
        isError={isError}
        HandleArrow={HandleArrow}
        checkClampLines={checkClampLines}
        setCheckClampLines={setCheckClampLines}
        handlePlay={handlePlay}
        HandlePauseVideo={HandlePauseVideo}
        videoRef={videoRef}
        isEqual={isEqual}
        HandleNextVideo={HandleNextVideo}
        innerWidth={innerWidth}
        videoUrl={videoUrl}
        pdfUrl={pdfUrl}
        reviewStaric={reviewStaric}
        HandleStaric={HandleStaric}
        HandleSubmit={HandleSubmit}
      />
    </>
  );
};
export default VideoPlayerScreen;
